function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.02 48.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M48,46a2,2,0,0,1-2,2H2a2,2,0,0,1,0-4H46A2,2,0,0,1,48,46ZM.59,17.11A4.87,4.87,0,0,1,.89,12,9.43,9.43,0,0,1,4.23,9l15-7.81a10.33,10.33,0,0,1,9.55,0L43.79,9h0a9.53,9.53,0,0,1,3.34,3,4.89,4.89,0,0,1,.3,5.14A5.41,5.41,0,0,1,42.6,20H42V36h2a2,2,0,0,1,0,4H4a2,2,0,0,1,0-4H6V20H5.42A5.4,5.4,0,0,1,.59,17.11ZM10,36h6V20H10ZM20,20V36h8V20Zm18,0H32V36h6ZM4.13,15.26A1.44,1.44,0,0,0,5.42,16H42.6a1.43,1.43,0,0,0,1.29-.75.89.89,0,0,0,0-1,5.26,5.26,0,0,0-1.9-1.73h0l-15-7.82a6.36,6.36,0,0,0-5.85,0l-15,7.82a5.53,5.53,0,0,0-1.9,1.73A.93.93,0,0,0,4.13,15.26Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.00d0e2e1.svg";
export { ForwardRef as ReactComponent };